/**
 * API Configuration
 * 
 * In development, we use relative paths ('/api/...') which are proxied by package.json proxy.
 * In production, we use the REACT_APP_API_URL environment variable.
 * 
 * However, the user request wants a unified way that works for both.
 * If REACT_APP_API_URL is set, we use it. If not, we fall back to relative path (or empty string pre-pend).
 */

const getProductionApiUrl = () => {
    if (typeof window === 'undefined') return '';

    const { protocol, hostname } = window.location;
    if (hostname === 'admin.esanza.com' || hostname === 'esanza.com' || hostname === 'www.esanza.com') {
        return `${protocol}//api.esanza.com`;
    }

    return '';
};

const API_BASE_URL = process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : getProductionApiUrl());

// Sanitize API_BASE_URL to remove trailing slash and a trailing /api.
// Dashboard calls already pass endpoints like /api/..., so this accepts either:
// REACT_APP_API_URL=https://api.esanza.com
// REACT_APP_API_URL=https://api.esanza.com/api
const sanitizedBaseUrl = API_BASE_URL.replace(/\/$/, '').replace(/\/api$/, '');

export const getApiUrl = (endpoint: string): string => {
    // Ensure endpoint starts with /
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${sanitizedBaseUrl}${cleanEndpoint}`;
};

export const API_URL = sanitizedBaseUrl;

export default sanitizedBaseUrl;
